<template>
<div class="index is-search" :style="{paddingTop: $store.state.headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true" :showNav="false"></SubHeader>
  <div class="level" v-for="(item, index) of menuData.slice(0,2)" :key="index">
    <b>{{item.category_name}}</b>
    <PriceCard v-for="(v, i) of item.goods"  :key="i" :index="index" :cardData="v"></PriceCard>
  </div>
  
</div>
</template>

<script>
import PriceCard from "@/components/PriceCard";
import SubHeader from "@/components/SubHeader2";
import { resolve } from "path";
import { Toast } from "vant";

// import Vue from 'vue'
// import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

export default {
  components: {
    PriceCard,
    SubHeader,
  },
  computed: {
    titleName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
  },
  data() {
    return {
      tabActive: "index",
      active: 0,
      pageLoading: true,
      listLoading: false,
      swiperData: [],
      menuData: [],
      hotData: [],
      qualityData: [],
      topData: [],
      limit: 10,
      current: 0,
      liveData: [],
      certData: [],
      vipInfo:{},
      demonstrate:[],
      
    };
  },
  async mounted() {
    console.log(this.$route)
    console.log(this.$until.isWeiXin())
    this.init();
  },
  methods: {
   
    will() {
      this.$toast('敬请期待');
    },
    change(event) {
      this.current = event.detail.current;
    },
    
    async init() {
      if(this.$until.isWeiXin()=='wxapp'){
        await this.$request.mobileLogin({
               mobile:this.$route.query.phone
             })
      }
      let res = await this.$api({
        // url: "/api/users/university/index",
        url: `/api/platform/pc/index?plat_id=${this.plat}&terminal=1`,
      });
      this.pageLoading = false;
      if (res.code == 0) {
        let {
          category,
          content_knowledge,
          like,
          choice_course,
          top_list,
          banner,
          live_stream,
          certificate,
          p_vip,
          vip_end_days,
          plat_vip,
          demonstrate
        } = res.data;
        this.demonstrate = demonstrate
        this.menuData = category;
        this.hotData = content_knowledge;
        this.qualityData = choice_course;
        this.topData = top_list;
        this.swiperData = banner;
        this.liveData = live_stream;
        this.certData = certificate;
        this.vipInfo = plat_vip;
        this.pageLoading = false;
        // this.$store.commit('SET_VIP',plat_vip)
      } else {
        this.$toast(res.msg);
      }
    },
    jumpUser() {},
    async getUser() {
      let res = await this.$api({
        url: "/api/auth/me",
      });
      if (res.code == 0) {
        this.$store.commit("setUser", res.data);
      }
    },
    toPage(url){
      if(url) window.location.href = url
    },
    goDetail(id) {
      let url = `./detail?id=${id}`
     
      this.$router.push(url);
    },
    goLiveDetail(item) {
      let {
        name,
        video_url,
        host,
        img_url,
        category_name,
        video_id,
        ccid,
        cover,
        id
      } = item;
      let videoId = video_id;
      let type = 'aliyun'
      if (ccid) {
        id = ccid;
        type = 'cc';
      }
      if (video_url) {
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${video_url}&host=${host}&cover=${img_url}&category_name=${category_name}`);
      } else if(videoId){
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&videoId=${videoId}&type=${type}&cover=${cover}`);

      } else {
        this.$toast('没有视频')
      }

    },
    goList(type) {
      this.$router.push(`./${type}`);
    },
    goProductList(index) {
      if (this.plat == 118 || this.plat == 119) {
        this.will();
      } else {
        this.$router.push(`./lesson?index=${index}`);
      }
    },
    toVIP(){
      if(!localStorage.getItem('token')){
        this.$dialog.confirm({
          title: '提示',
          message: '请登录后查看',
          confirmButtonText:'立即登录',
        })
          .then(() => {
            // on confirm
            this.$router.push('./login/phone')
          })
          .catch(() => {
            // on cancel
          });
      }else{
        this.$router.push({
          path:'./vip/detailVIP',
          query:{
            id:this.vipInfo.goods_id
          }
        })
      }
    }
  },
};
</script>

<style lang="scss">
  .my-swipe{
    width: 690px;
    margin: 10px auto 0;
    img{
      width: 100%;
      border-radius: 10px;
    }
  }
  .index-vip {
    width: 690px;
    height: 172px;
    margin: 23px auto 18px;
    display: block;
    background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/vip.png') no-repeat;
    background-size: 100%;
    position: relative;
  }
 
  .index-vip2 {
    width: 690px;
    height: 172px;
    margin: 23px auto 18px;
    display: block;
    background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/isVipBg.png') no-repeat;
    background-size: 100%;
    position: relative;
  }
  .index-vip2 .content{
  position: absolute;
  left:30px;
  top:40px;
  color: #6a4a2c;
  font-size: 24px;
}
.index-vip2 .content b{
  display: block;
  font-weight: bold;
  font-size: 34px;
  margin-bottom: 15px;
}
.index-vip
 .btn, .index-vip2 .btn {
  position: absolute;
  bottom: 37px;
  right: 37px;
  width: 155px;
  height: 56px;
  background: #6a4a2c;
  border-radius: 28px;
  text-align: center;
  line-height: 56px;
  color: #fff;
  font-size: 26px;
}
.index {
  min-height: 100vh;
  overflow: hidden;
}

.is-search {
  padding-top: 100px;
  box-sizing: border-box;
}
.tab{
  // padding-top: 35px;
}
.tab-class {
  color: #333;
  font-size: 30px;
}

.tab-warp {
  // height: calc(100vh - 88px - 96px);
  padding-bottom: 10px;
}

.tab-list {
  // height: calc(100vh - 88px - 96px);
  padding: 30px 0 0;
  box-sizing: border-box;
  overflow: hidden;
}

.swiper-wrap {
  width: 690px;
  height: 270px;
  margin: 11px auto 0;
  overflow: hidden;
  background: #fff;
  position: relative;
}

.swiper {
  height: 100%;
  width: 100%;
}

.swiper-item {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: 12px;
}

.page {
  position: absolute;
  right: 19px;
  bottom: 14px;
  color: #fff;
  font-size: 24px;
  letter-spacing: 2px;
  height: 40px;
  line-height: 40px;
  padding: 0 18px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.2);
}

.menu {
  width: 100vw;
  display: flex;
  align-items: center;
  padding: 0 5px;
  flex-wrap: wrap;

  .item {
    flex: 0 1 148px;
    width: 148px;
    text-align: center;
    margin-top: 40px;
  }

  .icon {
    width: 78px;
    height: 78px;
    display: inline-block;
    margin-bottom: 10px;
  }

  .name {
    font-size: 24px;
    color: #333333;
    line-height: 33px;
  }

  .line {
    width: 690px;
    height: 2px;
    background: #eee;
    margin: 34px auto 10px;
  }
}
.level{
  >b{
    font-size: 30px;
    padding: 0 0.4rem 0.2rem;
    display: block;
  }
}
.hot {
  width: 100vw;

  .hot-list {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }
}

.quality {
  width: 100vw;

  .quality-list {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

.top {
  width: 100vw;

  .top-list {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;
    overflow: auto;
  }

  .list-wrap {
    white-space: nowrap;
    // width: 100%;
  }
}
</style>
